import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  TextField,
  useTheme,
} from "@material-ui/core";
import React from "react";
import { CollectionService } from "../services";
import * as yup from "yup";
import { Formik } from "formik";

interface IProps {
  open: boolean;
  onClose: () => void;
}

export interface IPublishAggregationForm {
  destCollection: string;
  aggregationName: string;
  description: string;
  dateField: string;
  refreshTime: number | undefined;
}

const initialForm: IPublishAggregationForm = {
  destCollection: "",
  aggregationName: "",
  description: "",
  dateField: "insert_date_",
  refreshTime: 2,
};

const publishAggregationValidationSchema = yup.object().shape<IPublishAggregationForm>({
  destCollection: yup.string().required("Please enter Dest collection"),
  aggregationName: yup.string().required("Please enter aggregation name"),
  description: yup.string().required("Please enter description"),
  dateField: yup.string().required("Please enter date field"),
  refreshTime: yup.number().required("Please enter refresh time"),
});

const PublishAggregationModal: React.FC<IProps> = ({ open, onClose }) => {
  const theme = useTheme();

  const handlePublishAggregation = (value: IPublishAggregationForm) => {
    CollectionService.publishAggregation(value);
    onClose();
  };

  return (
    <Dialog open={open} fullWidth onClose={onClose}>
      <DialogTitle
        style={{
          backgroundColor: theme.palette.primary.main,
          color: theme.palette.text.secondary,
        }}
      >
        Publish aggregation
      </DialogTitle>
      <Formik
        validationSchema={publishAggregationValidationSchema}
        initialValues={{ ...initialForm }}
        onSubmit={async (values: IPublishAggregationForm) => {
          handlePublishAggregation(values);
        }}
      >
        {({
          handleSubmit,
          values,
          handleChange,
          handleBlur,
          touched,
          errors,
        }) => (
          <form noValidate autoComplete="off" onSubmit={handleSubmit}>
            <DialogContent>
              <TextField
                autoFocus
                fullWidth
                style={{ marginBottom: theme.spacing(2) }}
                variant="outlined"
                placeholder="Dest collection"
                name="destCollection"
                value={values.destCollection}
                onChange={handleChange}
                onBlur={handleBlur}
                helperText={touched.destCollection && errors.destCollection}
                error={touched.destCollection && Boolean(errors.destCollection)}
              />
              <TextField
                fullWidth
                style={{ marginBottom: theme.spacing(2) }}
                variant="outlined"
                placeholder="Aggregation name"
                name="aggregationName"
                value={values.aggregationName}
                onChange={handleChange}
                onBlur={handleBlur}
                helperText={touched.aggregationName && errors.aggregationName}
                error={
                  touched.aggregationName && Boolean(errors.aggregationName)
                }
              />
              <TextField
                fullWidth
                style={{ marginBottom: theme.spacing(2) }}
                variant="outlined"
                placeholder="Description"
                name="description"
                value={values.description}
                onChange={handleChange}
                onBlur={handleBlur}
                helperText={touched.description && errors.description}
                error={touched.description && Boolean(errors.description)}
              />

              <TextField
                fullWidth
                style={{ marginBottom: theme.spacing(2) }}
                variant="outlined"
                placeholder="Date field (e.g. insert_date_)"
                name="dateField"
                value={values.dateField}
                onChange={handleChange}
                onBlur={handleBlur}
                helperText={touched.dateField && errors.dateField}
                error={touched.dateField && Boolean(errors.dateField)}
              />

              <TextField
                fullWidth
                style={{ marginBottom: theme.spacing(2) }}
                type="number"
                variant="outlined"
                placeholder="Refresh time"
                name="refreshTime"
                value={values.refreshTime}
                onChange={handleChange}
                onBlur={handleBlur}
                helperText={touched.refreshTime && errors.refreshTime}
                error={touched.refreshTime && Boolean(errors.refreshTime)}
              />
            </DialogContent>

            <Divider />
            <DialogActions>
              <Button
                style={{
                  textTransform: "none",
                  borderColor: theme.palette.error.light,
                  color: theme.palette.error.light,
                }}
                variant="outlined"
                disableRipple
                onClick={onClose}
              >
                Close
              </Button>
              <Button
                color="primary"
                type="submit"
                style={{ textTransform: "none" }}
                variant="outlined"
                disableRipple
              >
                Publish
              </Button>
            </DialogActions>
          </form>
        )}
      </Formik>
    </Dialog>
  );
};

export default PublishAggregationModal;
